import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, UserService } from '../..';
import { Jsonp, RequestOptions, Http, Headers, ResponseContentType } from '@angular/http';

@Injectable()
export class KhaiBaoKhachHangCmisService {

  constructor(private router: Router, private api: ApiService, private userService: UserService) { }
  //APIURL = "api/ImportFileXmlToOracle/";
  APIURL = "api/ExcuteOracle";

  //Lấy danh sách loại công tơ
  public layDanhSachLoaiCongTo() {
    var param = {
      "config": '{"namesql":"PKG_KHAIBAOKHACHHANG.P_LAYDS_LOAICONGTO"}',
      "para": '{}'
    };
    return this.api.Excute(this.APIURL, param);
  }


  public uploadXmlReturnJson(desFolder: string, overWrite: string, file: File, danhmucid: string) {
    let formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    formData.append('Desfolder', desFolder);
    formData.append('overWrite', overWrite);
    formData.append('danhmucID', danhmucid);
    let headers = new Headers()
    //headers.append('Content-Type', 'json');  
    //headers.append('Accept', 'application/json');  
    let options = new RequestOptions({ headers: headers });
    return this.api.Excute("api/ThongtinKHCmis/UploadXmlReturnJson", formData, options);
  }

  public uploadExcelReturnJson(desFolder: string, overWrite: string, file: File, danhmucid: string) {
    let formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    formData.append('Desfolder', desFolder);
    formData.append('overWrite', overWrite);
    formData.append('danhmucID', danhmucid);
    let headers = new Headers()
    //headers.append('Content-Type', 'json');  
    //headers.append('Accept', 'application/json');  
    let options = new RequestOptions({ headers: headers });
    return this.api.Excute("api/ThongtinKHCmis/UploadExcelReturnJson", formData, options);
  }

  public kiemTraKhachHang_XML(json: string, dieukienkhaibao: string, filetype: string ) {

    let formData: FormData = new FormData();
    formData.append('jsondata', json);
    formData.append('dieukienkhaibao', dieukienkhaibao);
    formData.append('filetype', filetype);
    //return this.http.post(ROOT_URL + "api/Cmis/Json2XmlFile", formData, options).map(res => res.json());
    return this.api.Excute("api/ThongtinKHCmis/kiemtra", formData);
  }

  public KhaibaoKhachHang_XML(json: string, dieukienkhaibao: string, filetype: string, danhmucid: string, mataikhoan: string) {

    let formData: FormData = new FormData();
    formData.append('jsondata', json);
    formData.append('dieukienkhaibao', dieukienkhaibao);
    formData.append('filetype', filetype);
    formData.append('danhmucid', danhmucid);
    formData.append('mataikhoan', mataikhoan);
    //return this.http.post(ROOT_URL + "api/Cmis/Json2XmlFile", formData, options).map(res => res.json());
    return this.api.Excute("api/ThongtinKHCmis/khaibao", formData);
  }


}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/nhap-thong-tin-kh/khai-bao-khach-hang-cmis/khaibaokhachhangcmis.service.ts